<form [formGroup]="verrekenbareVerliezenFG">
    <div *ngIf="onverrekendeVerliezenBox1.length > 0">
        <div formArrayName="onverrekendeVerliezenBox1">
            <div *ngFor="let verlies of onverrekendeVerliezenBox1.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Verlies box 1' : ''"
                                                  [options]="optionsJarenBox1"
                                                  [required]=true
                                                  class="col-auto custom-input-250"
                                                  formControlName="omschrijving"
                                                  id="verliesBox1"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control
                        (change)="saveForm()"
                        [class]="i === 0 ? 'col-auto custom-input-150 pt-3' : 'col-auto custom-input-150'"
                        [decimals]="0"
                        align="right"
                        formControlName="bedrag"
                        id="bedragBox1"
                        prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button
                        (click)="verwijderRijVerliesBox1(i)"
                        [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                        class="delete"
                        icon="trash"
                        id="buttonDeleteBox1"
                        size="medium"
                        type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>

    <div *ngIf="onverrekendeVerliezenBox1.length === 0">
        <snelstart-ui-button (click)="addRijVerliesBox1()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Onverrekende verliezen box 1
        </snelstart-ui-button>
    </div>
    <div *ngIf="onverrekendeVerliezenBox1.length > 0">
        <snelstart-ui-button (click)="addRijVerliesBox1()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Onverrekende verliezen box 1 toevoegen
        </snelstart-ui-button>
    </div>


    <div *ngIf="onverrekendeVerliezenBox2.length > 0">
        <div formArrayName="onverrekendeVerliezenBox2">
            <div
                    *ngFor="let verlies of onverrekendeVerliezenBox2.controls; let i = index; "
                    [formGroupName]="i" class="row">
                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                      *ngIf="aangifte.aangifteJaar < 2028"
                                                      [label]="i === 0 ? 'Verlies box 2' : ''"
                                                      [options]="optionsJarenBox2"
                                                      [required]=true
                                                      class="col-auto custom-input-250"
                                                      formControlName="omschrijving"
                                                      id="verliesBox2"
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 0 ? 'col-auto custom-input-150 pt-3' : 'col-auto custom-input-150'"
                            [decimals]="0"
                            align="right"
                            formControlName="bedrag"
                            id="bedragBox2"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button
                            (click)="verwijderRijVerliesBox2(i)"
                            [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto'"
                            icon="trash"
                            class="delete"
                            id="buttonDeleteBox2"
                            size="medium"
                            type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
        </div>
    </div>

    <div *ngIf="onverrekendeVerliezenBox2.length === 0">
        <snelstart-ui-button (click)="addRijVerliesBox2()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Onverrekende verliezen box 2
        </snelstart-ui-button>
    </div>
    <div *ngIf="onverrekendeVerliezenBox2.length > 0">
        <snelstart-ui-button (click)="addRijVerliesBox2()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Onverrekende verliezen box 2 toevoegen
        </snelstart-ui-button>
    </div>

    <div *ngIf="belastingkortingBox2.length > 0">
        <div formArrayName="belastingkortingBox2">
            <div *ngFor="let verlies of belastingkortingBox2.controls; let i = index; "
                    [formGroupName]="i"  class="row">

                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                      [label]="i === 0 ? 'Belastingkorting box 2' : ''"
                                                      [options]="optionsJarenBox1"
                                                      [required]=true
                                                      class="col-auto custom-input-250"
                                                      formControlName="omschrijving"
                                                      id="verliesBox2bk"
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 0 ? 'col-auto custom-input-150 pt-3' : 'col-auto custom-input-150'"
                            [decimals]="0"
                            align="right"
                            formControlName="bedrag"
                            id="bedragKortingBox2"
                            prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button
                            (click)="verwijderRijBelastingkortingBox2(i)"
                            [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                            icon="trash"
                            class="delete"
                            id="buttonDeleteKortingBox2"
                            size="medium"
                            type="secondary"
                    >
                    </snelstart-ui-button>
                 </div>
        </div>
    </div>

    <div *ngIf="belastingkortingBox2.length === 0">
        <snelstart-ui-button (click)="addRijBelastingkortingBox2()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Belastingkorting box 2
        </snelstart-ui-button>
    </div>
    <div *ngIf="belastingkortingBox2.length > 0">
        <snelstart-ui-button (click)="addRijBelastingkortingBox2()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Belastingkorting box 2 toevoegen
        </snelstart-ui-button>
    </div>
</form>

<form [formGroup]="verrekenbareVerliezenFG">
    <div *ngIf="onverrekendeBuitenlandseBronheffing.length > 0">
        <div formArrayName="onverrekendeBuitenlandseBronheffing">
            <div *ngFor="let verlies of onverrekendeBuitenlandseBronheffing.controls; let i = index; "
                    [formGroupName]="i" class="row">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Omschrijving' : ''"
                                                    class="col-auto custom-input-250"
                                                    formControlName="omschrijving"
                                                    id="omschrijvingBronheffing"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Bedrag' : ''"
                                                      align="right"
                                                      class="col-auto custom-input-150"
                                                      formControlName="bedrag"
                                                      id="bedragBronheffing"
                                                      prefix="€">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (click)="verwijderRijOnverrekendeBuitenlandseBronheffing(i)"
                                         [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                         class="delete"
                                         id="buttonDeleteBronheffing"
                                         icon="trash"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
        </div>
    </div>

    <div *ngIf="onverrekendeBuitenlandseBronheffing.length === 0">
        <snelstart-ui-button (click)="addRijOnverrekendeBuitenlandseBronheffing()" class="snelstart-ui-button" icon="plus"
                             type="link">Onverrekende buitenlandse
            bron-/dividendbelasting
        </snelstart-ui-button>
    </div>
    <div *ngIf="onverrekendeBuitenlandseBronheffing.length > 0">
        <snelstart-ui-button (click)="addRijOnverrekendeBuitenlandseBronheffing()" class="snelstart-ui-button" icon="plus"
                             type="link">Buitenlandse bron-/dividendbelasting
            toevoegen
        </snelstart-ui-button>
    </div>

</form>
